import { PanelLeft } from "lucide-react"
import { useState, type ReactNode } from "react"

import { AppSidebar } from "@/components/app-sidebar"
import { Button } from "@/components/ui/button"

export default function Layout({ children }: { children: ReactNode }) {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <div className="hidden md:flex">
        <AppSidebar />
      </div>

      {mobileOpen ? (
        <div className="fixed inset-0 z-40 flex md:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setMobileOpen(false)} />
          <div className="relative z-10" onClick={() => setMobileOpen(false)}>
            <AppSidebar />
          </div>
        </div>
      ) : null}

      <main className="flex min-w-0 flex-1 flex-col bg-background">
        <div className="flex h-[52px] items-center border-b border-border px-3 md:hidden">
          <Button variant="ghost" size="icon-sm" onClick={() => setMobileOpen(true)}>
            <PanelLeft />
          </Button>
        </div>
        {children}
      </main>
    </div>
  )
}
